const SERVICES = [
  {
    key: "resources", color: "#5A2D9C", title: "Community resource connections",
    text: "Helping people identify and connect with organizations that offer support for housing, food, health, and other essential needs.",
    img: "/assets/svc-resources.jpg", alt: "Volunteers sharing resource brochures with families at an outdoor community table",
    icon: <><circle cx="6" cy="6" r="3" /><circle cx="18" cy="18" r="3" /><path d="M8.5 8.5l7 7M18 6h.01M6 18h.01" /></>,
  },
  {
    key: "homeless", color: "#D99A00", title: "Homelessness support",
    text: "Connecting people experiencing homelessness with available community resources and, when possible, providing donated essentials.",
    img: "/assets/svc-homeless.jpg", alt: "Volunteers handing a bag of donated essentials to a neighbor",
    icon: <><path d="M3 11l9-7 9 7" /><path d="M5 10v10h14V10" /><path d="M12 17s-3-1.8-3-3.6A1.6 1.6 0 0 1 12 13a1.6 1.6 0 0 1 3 .4C15 15.2 12 17 12 17z" /></>,
  },
  {
    key: "mental", color: "#7B3FE4", title: "Mental health resources",
    text: "Helping individuals and families find information and connections to mental health support in their community.",
    img: "/assets/svc-mental.jpg", alt: "A supportive conversation between two women on a couch",
    icon: <><path d="M9.5 21v-3H7a2 2 0 0 1-2-2v-3l-2-1 2-3.5A7 7 0 0 1 19 9c0 2.5-1 4.3-2.5 5.5V21" /><path d="M12 12.5s-2.5-1.5-2.5-3a1.3 1.3 0 0 1 2.5-.5 1.3 1.3 0 0 1 2.5.5c0 1.5-2.5 3-2.5 3z" /></>,
  },
  {
    key: "autism", color: "#2B78D0", title: "Autism and disability support",
    text: "Sharing resources and connecting individuals, families, and caregivers with organizations that support autism and disability inclusion.",
    img: "/assets/svc-autism.jpg", alt: "Children, including a child in a wheelchair, playing with colorful puzzle pieces",
    icon: <><circle cx="11" cy="4" r="2" /><path d="M11 7v6h5l2 6" /><path d="M8 10.5A5.5 5.5 0 1 0 15.5 18" /></>,
  },
  {
    key: "seniors", color: "#C2337A", title: "Seniors and caregivers",
    text: "Helping older adults and caregivers find information, community resources, and support for their day-to-day needs.",
    img: "/assets/svc-seniors.jpg", alt: "A caregiver holding hands with an older couple on a sunny porch",
    icon: <><circle cx="8" cy="5" r="2" /><circle cx="16" cy="5" r="2" /><path d="M6 21v-7l-1-1 1-4h4l1 4-1 1v7M14 21v-6h-1l1-6h4l1 6h-1v6" /></>,
  },
  {
    key: "events", color: "#1E9E5A", title: "Community events and outreach",
    text: "Bringing neighbors and partner organizations together through resource events, donation drives, and opportunities to connect.",
    img: "/assets/svc-events.jpg", alt: "Neighbors gathering under tents at an outdoor community event in a park",
    icon: <><path d="M3 21l3-12 12 6-15 6z" /><path d="M14 4l1 2M19 3l-1 3M21 8l-3 1M10 7c1-1 2-1 3 0" /></>,
  },
];

export const Services = () => (
  <section className="sec" id="services" data-testid="services-section">
    <div className="wrap">
      <div className="head">
        <h2>How we support our community</h2>
        <p>Davis Infinite Care Corporation helps individuals and families connect with resources, community partners, and compassionate support.</p>
      </div>
      <div className="svc">
        {SERVICES.map((s) => (
          <article key={s.key} data-testid={`service-card-${s.key}`}>
            <div className="svc-img"><img src={s.img} alt={s.alt} loading="lazy" /></div>
            <div className="ico" style={{ background: s.color }}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{s.icon}</svg>
            </div>
            <h3>{s.title}</h3>
            <p>{s.text}</p>
          </article>
        ))}
      </div>
      <p className="note">
        Our activities and available assistance may vary by program and event. Not sure where to start?{" "}
        <a href="#contact" data-testid="services-reach-out-link">Reach out</a> and we'll help point you in the right direction.
      </p>
    </div>
  </section>
);
